import React from 'react'
import PinModal from '@/modules/banking/components/pin-modal/pin-modal'
import { CancelPinRequestError } from '../errors'

import store from '@/redux/store'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openPinModal = ({ transaction, processId, onSuccess, onError, onAbort = () => { } }) => {
  const { transactionId } = transaction
  return new Promise((resolve, reject) => {
    const getComponent = (close) => {
      return (
        <div data-transaction-id={transactionId}>
          <PinModal
            open={true}
            processId={processId}
            store={store}
            transaction={transaction}
            onSuccess={(data) => {
              close()
              onSuccess(data)
              resolve(data)
            }}
            onError={(error) => {
              close()
              onError(error)
              reject(error)
            }}
            onAbort={() => {
              close()
              onAbort()
              reject(new CancelPinRequestError(transaction))
            }}
          />
        </div>
      )
    }
    renderElement(getComponent)
  })
}

export default openPinModal
